import { render, staticRenderFns } from "./PlaDedicacio.vue?vue&type=template&id=8fc74b62&"
import script from "./PlaDedicacio.vue?vue&type=script&lang=js&"
export * from "./PlaDedicacio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports